import React from 'react';
import { Link } from 'react-router';

import { navClassName, itemVariants } from './BottomNavBar.variants';

export interface IBottomNavBarProps {
  currentPath: string;
}

interface INavItem {
  icon: React.JSX.Element;
  label: string;
  route: string;
  testId: string;
  condition?: boolean;
}

function ListIcon(): React.JSX.Element {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 6H21M8 12H21M8 18H21M3 6H3.01M3 12H3.01M3 18H3.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function TemplateIcon(): React.JSX.Element {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 3H10V10H3V3ZM14 3H21V10H14V3ZM3 14H10V21H3V14ZM14 14H21V21H14V14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function InviteIcon(): React.JSX.Element {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d={
          'M16 21V19C16 16.7909 14.2091 15 12 15H5C2.79086 15 1 16.7909 1 19V21' +
          'M20 8V14M23 11H17' +
          'M12.5 7C12.5 9.20914 10.7091 11 8.5 11C6.29086 11 4.5 9.20914 4.5 7' +
          'C4.5 4.79086 6.29086 3 8.5 3C10.7091 3 12.5 4.79086 12.5 7Z'
        }
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SettingsIcon(): React.JSX.Element {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d={
          'M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9' +
          'C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z'
        }
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d={
          'M19.4 15C19.1277 15.6171 19.2583 16.3378 19.73 16.82L19.79 16.88' +
          'C20.1656 17.2551 20.3766 17.7642 20.3766 18.295' +
          'C20.3766 18.8258 20.1656 19.3349 19.79 19.71' +
          'C19.4149 20.0856 18.9058 20.2966 18.375 20.2966' +
          'C17.8442 20.2966 17.3351 20.0856 16.96 19.71L16.9 19.65' +
          'C16.4178 19.1783 15.6971 19.0477 15.08 19.32' +
          'C14.4755 19.5791 14.0826 20.1724 14.08 20.83V21' +
          'C14.08 22.1046 13.1846 23 12.08 23C10.9754 23 10.08 22.1046 10.08 21V20.91' +
          'C10.0642 20.2327 9.63587 19.6339 9 19.4' +
          'C8.38291 19.1277 7.66219 19.2583 7.18 19.73L7.12 19.79' +
          'C6.74493 20.1656 6.23584 20.3766 5.705 20.3766' +
          'C5.17416 20.3766 4.66507 20.1656 4.29 19.79' +
          'C3.91445 19.4149 3.70343 18.9058 3.70343 18.375' +
          'C3.70343 17.8442 3.91445 17.3351 4.29 16.96L4.35 16.9' +
          'C4.82167 16.4178 4.95229 15.6971 4.68 15.08' +
          'C4.42093 14.4755 3.82764 14.0826 3.17 14.08H3' +
          'C1.89543 14.08 1 13.1846 1 12.08C1 10.9754 1.89543 10.08 3 10.08H3.09' +
          'C3.76733 10.0642 4.36613 9.63587 4.6 9' +
          'C4.87229 8.38291 4.74167 7.66219 4.27 7.18L4.21 7.12' +
          'C3.83445 6.74493 3.62343 6.23584 3.62343 5.705' +
          'C3.62343 5.17416 3.83445 4.66507 4.21 4.29' +
          'C4.58507 3.91445 5.09416 3.70343 5.625 3.70343' +
          'C6.15584 3.70343 6.66493 3.91445 7.04 4.29L7.1 4.35' +
          'C7.58219 4.82167 8.30291 4.95229 8.92 4.68H9' +
          'C9.60455 4.42093 9.99764 3.82764 10 3.17V3' +
          'C10 1.89543 10.8954 1 12 1C13.1046 1 14 1.89543 14 3V3.09' +
          'C14.0024 3.74764 14.3955 4.34093 15 4.6' +
          'C15.6171 4.87229 16.3378 4.74167 16.82 4.27L16.88 4.21' +
          'C17.2551 3.83445 17.7642 3.62343 18.295 3.62343' +
          'C18.8258 3.62343 19.3349 3.83445 19.71 4.21' +
          'C20.0856 4.58507 20.2966 5.09416 20.2966 5.625' +
          'C20.2966 6.15584 20.0856 6.66493 19.71 7.04L19.65 7.1' +
          'C19.1783 7.58219 19.0477 8.30291 19.32 8.92V9' +
          'C19.5791 9.60455 20.1724 9.99764 20.83 10H21' +
          'C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14H20.91' +
          'C20.2524 14.0024 19.6591 14.3955 19.4 15Z'
        }
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function isActive(currentPath: string, route: string): boolean {
  return currentPath.startsWith(route);
}

export function BottomNavBar(props: IBottomNavBarProps): React.JSX.Element {
  const { currentPath } = props;

  const navItems: INavItem[] = [
    { icon: <ListIcon />, label: 'Lists', route: '/lists', testId: 'nav-lists' },
    { icon: <TemplateIcon />, label: 'Templates', route: '/templates', testId: 'nav-templates' },
    { icon: <InviteIcon />, label: 'Invite', route: '/users/invitation/new', testId: 'nav-invite' },
    { icon: <SettingsIcon />, label: 'Settings', route: '/settings', testId: 'nav-settings' },
  ];

  return (
    <nav className={navClassName} data-test-id="bottom-nav" aria-label="Main navigation" role="navigation">
      {navItems.map((item) => (
        <Link
          key={item.route}
          to={item.route}
          className={itemVariants({ active: isActive(currentPath, item.route) })}
          data-test-id={item.testId}
          aria-current={isActive(currentPath, item.route) ? 'page' : undefined}
        >
          {item.icon}
          <span className="tw:text-xs tw:font-medium">{item.label}</span>
        </Link>
      ))}
    </nav>
  );
}
